<template>
	<div 
		v-if="criterias.length > 0"
		class="col-12 px-0 mb-5 text-start">
		<h3>
			<span class="title-3 text-grey-900">
				{{ content.planner_prestationsAdvantages }}
			</span>
			<!-- <span class="d-md-none weight-700 font-18">
				{{ content.planner_prestationsAdvantages }}
			</span> -->
		</h3>

		<div class="d-flex flex-row flex-wrap pe-4 px-lg-0">
			<div
				v-for="(criteria, criteria_i) in criterias"
				:key="criteria_i"
				class="col-6 col-md-4 col-lg-3 ps-0 pe-3 mt-1 mb-2 mb-md-1 d-flex flex-row nowrap"
			>
				<div class="me-1">
					<svg
						:width="svgSize"
						:height="svgSize"
						class="icon text-primary-blue"
					>
						<use :xlink:href="`#___icon___${criteria.svgName}`"></use>
					</svg>
				</div>
				<span class="font-weight-600 font-14 m-1">{{ criteria.label }} </span>
			</div>
		</div>
	</div>
</template>

<script>
// import BorderHorizontal from "@/vue/common/borderHorizontal.vue";
import { mapState, mapGetters } from "vuex";
import store from "@/vue/planning/store/store";

export default {
	store,
	name: "Advantages",
	props: {
		prestation: {
			type: Object,
			default: () => {
				return {};
			},
		},
		quantity: {
			type: Number,
			default: 6,
		},
		svgSize: {
			type: Number,
			default: 20,
		},
	},
	components: {
		// BorderHorizontal,
	},
	data() {
		return {};
	},
	computed: {
		...mapState(["content"]),
		...mapGetters(["advantages_criterias"]),
		criterias() {
			return this.advantages_criterias[this.prestation.prestationId] || [];
		}
	},
};
</script>
